import styled from "styled-components";
import { medals } from "../../../../constants/medals";

export const Container = styled.div<{ unlockOrder?: number }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0px;
  ${({ unlockOrder }) => unlockOrder ? `background: ${medals[unlockOrder - 1]?.background_vertical || "#EEE"};` : ""}
  border-radius: 12px;
  position: relative;
  flex-shrink: 0;
  flex-direction: column;
  width: 100%;
  padding: 36px 22px;
  max-width: 285px;

  @media(min-width: 768px){
    padding: 28px;
    max-width: 400px;
  }
`;


export const UnlockedCategoryCarouselContainer = styled.div`
  padding: 12px 0px;
  border-radius: 0px;
  padding: 30px 0px 34px;
  background-color: ${({ theme }) => theme.colors?.Primary05};

  @media(min-width: 768px){
    padding: 34px 0px;
    border-radius: 12px;
  }
`

export const Medal = styled.div`
  
`;

export const Content = styled.div<{ color?: string }>`
  width: 100%;

  h4 {
    margin: 0px;
    font-size: 14px;
    color: ${({ color }) => !color ? "#2D3436" : color === "black" ? "#2D3436" : "white"};
    font-weight: 500;
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 18px;
    }
  }

  h2 {
    margin: 0px;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    color: ${({ color }) => !color ? "black" : color === "black" ? "black" : "white"};
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    padding: 0px 20px;
    text-align: center;
  }
`;

export const ExploreButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgb(45, 52, 54);
  padding: 0px 16px;
  color: white;
  height: 31px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;

  &:hover {
    opacity: 0.85;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 13px;
  right: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0px;

  @media (max-width: 768px) {
    top: 9px;
    right: 10px;
  }
`;

export const Title = styled("h3")`
  margin: 0px;
  font-weight: 600;
  font-size: 20px;
  line-height: normal;

  @media (min-width: 768px) {
    font-size: 28px;
  }
`;

export const Subtitle = styled.p`
font-size: 16px;
font-weight: normal;
margin: 0;
`

export const ToogleButton = styled.button`
  padding: 0px;
  border: 0px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: transparent;
  min-height: 24.5px;
  cursor: pointer;
  
  @media (min-width: 768px) {
    padding: 12px 16px;
    border: 1px solid #2D3436;
  }
 
  &.minimized {
    padding: 8px 12px;
    border: 1px solid #2D3436;
    font-size: 12px;
    font-weight: 600;

    @media (min-width: 768px) {
      padding: 12px 16px;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }
  }
`

export const Flex = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`



export const UnlockedCategoryBadgeContainer = styled.div`
  padding: 22px 12px;
  border: 2px solid ${({ theme }) => theme.colors?.Primary};
  background-color: ${({ theme }) => theme.colors?.Primary20};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  max-width: calc(100% - 20px);
  margin: 0 auto;

  @media(min-width: 768px){
    max-width: 100%;
    padding: 34px 44px;
  }

  ${Title} {
    @media(max-width: 797px){
      font-size: 14px;
      font-weight: normal;

      span {
        display: block;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
`

export const New = styled.div`
  border: 1px solid rgba(255,255,255,.6);;
  background-color: rgba(255,255,255,.3);
  color: black;
  text-transform: uppercase;
      font-style: italic;
      padding: 12px;
      border-radius: 30px;
          position: absolute;
    right: 17px;
    font-size: 12px;
    top: 17px;
}
`